import React from 'react';
import { connect } from 'react-redux';
import {
  FacebookLogo,
  LinkedinLogo,
  InstagramLogo,
  YoutubeLogo,
} from 'phosphor-react';

import { STORE_LINKS, SOCIAL_LINKS, LOGO_SRC } from './homeContent';

const SOCIAL_ICONS = {
  linkedin: LinkedinLogo,
  facebook: FacebookLogo,
  instagram: InstagramLogo,
  youtube: YoutubeLogo,
};

// Shared footer of the public site (home, contact, buy-now pages).
const SiteFooter = ({ localizations }) => (
  <footer className="op-footer">
    <div className="op-wrap op-footer__grid">
      <div>
        <img className="op-footer__logo" src={LOGO_SRC} alt="Okuma Platformu" />
        <p>Okul öncesi ve ilkokul öğrencileri için sesli, resimli dijital okuma platformu.</p>
        <ul className="op-social">
          {SOCIAL_LINKS.map((social) => {
            const Icon = SOCIAL_ICONS[social.key];
            return (
              <li key={social.key}>
                <a href={social.href} target="_blank" rel="noreferrer" aria-label={social.label}>
                  <Icon size={20} weight="fill" />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
      <div>
        <h3>Platform</h3>
        <ul>
          <li><a href="/signin">Giriş Yap</a></li>
          <li><a href="/forgot-password">Şifremi Unuttum</a></li>
          <li><a href="/buy-now">Satın Al</a></li>
          <li><a href="/contact">İletişim</a></li>
        </ul>
      </div>
      <div>
        <h3>Uygulamalar</h3>
        <ul>
          <li><a href={STORE_LINKS.okul.appStore} target="_blank" rel="noreferrer">Okul · App Store</a></li>
          <li><a href={STORE_LINKS.okul.googlePlay} target="_blank" rel="noreferrer">Okul · Google Play</a></li>
          <li><a href={STORE_LINKS.bireysel.appStore} target="_blank" rel="noreferrer">Bireysel · App Store</a></li>
          <li><a href={STORE_LINKS.bireysel.googlePlay} target="_blank" rel="noreferrer">Bireysel · Google Play</a></li>
        </ul>
      </div>
      <div>
        <h3>Yasal</h3>
        <ul>
          <li><a href="/kvkk">{localizations?.FOOTER_KVKK_BTN ?? 'KVKK'}</a></li>
          <li><a href="/terms-of-use">Kullanım Koşulları</a></li>
        </ul>
      </div>
    </div>
    <p className="op-footer__copy">
      © {new Date().getFullYear()}{' '}
      <a href="https://www.edictdigital.com/" target="_blank" rel="noreferrer">
        Edict Digital
      </a>
      . Tüm hakları saklıdır.
    </p>
  </footer>
);

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
});

export default connect(mapStateToProps)(SiteFooter);
